import { useMemo } from "react";
import { matchRoutes, Outlet, useLocation } from "react-router-dom";
import FreshpaintProvider from "src/context/FreshpaintContext";
import { SessionContextProvider } from "src/context/SessionContext";

const UNWRAPPED_PATHS = [
  "/:language/:product/welcome",
  "/:language/:product/welcome-2",
];

function RootLayout() {
  const location = useLocation();

  const isUnwrapped = useMemo(
    () =>
      Boolean(
        matchRoutes(
          UNWRAPPED_PATHS.map((path) => ({ path })),
          { pathname: location.pathname }
        )
      ),
    [location.pathname]
  );

  if (isUnwrapped) {
    return (
      <FreshpaintProvider>
        <Outlet />
      </FreshpaintProvider>
    );
  }

  return (
    <SessionContextProvider>
      <FreshpaintProvider>
        <Outlet />
      </FreshpaintProvider>
    </SessionContextProvider>
  );
}

export default RootLayout;
